import { MessagePanel } from 'view-layer/components/layout';
import { useLocation } from 'react-router-dom';
import { useDocumentTitle } from 'business-layer/hooks/useDocumentTitle';

export const Error = ({ message = ''}: { message?: string }) => {
  useDocumentTitle('Something went wrong');
  const { state } = useLocation();
  const errorMessage = message || (state as any)?.message || 'Something went wrong';
  const payByLinkId = (state as any)?.payByLinkId || null;
  return <MessagePanel type="error" message={errorMessage} paymentId={payByLinkId} />;
}
